module.exports = __webpack_public_path__ + "static/media/facebook-login.f69e91c7.svg";